import { render, staticRenderFns } from "./WidgetsDashboardCases.vue?vue&type=template&id=5c59c9d4"
import script from "./WidgetsDashboardCases.vue?vue&type=script&lang=js"
export * from "./WidgetsDashboardCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports